/**
 * Combine all reducers in this file and export the combined reducers.
 */

import { combineReducers } from 'redux';

import accountReducer from 'slice/accountSlice';
import addressReducer from 'slice/addressSlice';
import appReducer from 'slice/appSlice';
import areaReducer from 'slice/areaSlice';
import authReducer from 'slice/authSlice';
import autoOrderSettingDetailReducer from 'slice/autoOrderSettingDetailSlice';
import bankAccountReducer from 'slice/bankAccountSlice';
import bankReducer from 'slice/bankSlice';
import bannerReducer from 'slice/bannerSlice';
import branchReducer from 'slice/branchSlice';
import budgetItemReducer from 'slice/budgetItemSlice';
import campaignReducer from 'slice/campaignSlice';
import categoryReducer from 'slice/categorySlice';
import certificationReducer from 'slice/certificationSlice';
import chatReducer from 'slice/chatSlice';
import coBuyProductReducer from 'slice/coBuyProductSlice';
import coBuyReducer from 'slice/coBuySlice';
import collaboratorProductReducer from 'slice/collaboratorProductSlice';
import colorReducer from 'slice/colorSlice';
import comboReducer from 'slice/comboSlice';
import createOrderReducer from 'slice/createOrderSlice';
import customerGroupUserReducer from 'slice/customerGroupOrderSlice';
import customerReducer from 'slice/customerSlice';
import debtStatisticReducer from 'slice/debtStatisticSlice';
import diaryReducer from 'slice/diarySlice';
import digitalMenuCategoryProductReducer from 'slice/digitalMenuCategoryProductSlice';
import digitalMenuCategoryProposalItemReducer from 'slice/digitalMenuCategoryProposalItemSlice';
import digitalMenuCategoryReducer from 'slice/digitalMenuCategorySlice';
import digitalMenuReducer from 'slice/digitalMenuSlice';
import documentCategoryReducer from 'slice/documentCategorySlice';
import employeeReducer from 'slice/employeeSlice';
import entityAreaReducer from 'slice/entityAreaSlice';
import entityBudgetItemReducer from 'slice/entityBudgetItemSlice';
import entityCartItemReducer from 'slice/entityCartItemSlice';
import entityCategoryReducer from 'slice/entityCategorySlice';
import entityCertificationReducer from 'slice/entityCertificationSlice';
import entityCouponReducer from 'slice/entityCouponSlide';
import entityCustomShippingFeeReducer from 'slice/entityCustomShippingFeeSlice';
import entityDeliveryFeeReducer from 'slice/entityDeliveryFeeSlice';
import entityDiaryReducer from 'slice/entityDiarySlice';
import entityDistanceShippingFeeReducer from 'slice/entityDistanceShippingFeeSlice';
import entityGroupReducer from 'slice/entityGroupSlice';
import entityLarkAppReducer from 'slice/entityLarkAppSlice';
import entityLarkBaseReducer from 'slice/entityLarkBaseSlice';
import entityLocationExistReducer from 'slice/entityLocationExistSlice';
import entityEntityLocationFreeShipReducer from 'slice/entityLocationFreeShipSlide';
import entityLocationShippingFeeReducer from 'slice/entityLocationShippingFeeSlice';
import entityMaterialCategoryReducer from 'slice/entityMaterialCategorySlice';
import entityMaterialReducer from 'slice/entityMaterialSlice';
import entityMaterialSubCategoryReducer from 'slice/entityMaterialSubCategorySlice';
import entityOptionReducer from 'slice/entityOptionSlice';
import entityPackingFeeReducer from 'slice/entityPackingFeeSlice';
import entityRelativeQuantityReducer from 'slice/entityRelativeQuantitySlice';
import entitySettingReducer from 'slice/entitySettingSlice';
import entitySubCategoryReducer from 'slice/entitySubCategorySlice';
import galleryReducer from 'slice/gallerySlice';
import groupReducer from 'slice/groupSlice';
import invitationProductReducer from 'slice/invitationProductSlice';
import invitationReducer from 'slice/invitationSlice';
import locationReducer from 'slice/locationSlice';
import materialCategoryReducer from 'slice/materialCategorySlice';
import notificationReducer from 'slice/notificationSlice';
import optionReducer from 'slice/optionSlice';
import orderItemLogReducer from 'slice/orderItemLogSlice';
import orderItemsReducer from 'slice/orderItemSlice';
import orderReducer from 'slice/orderSlice';
import orderTaskReducer from 'slice/orderTaskSlice';
import organizationReducer from 'slice/organizationSlice';
import partnerReducer from 'slice/partnerSlice';
import pricePolicyReducer from 'slice/pricePolicySlice';
import processReducer from 'slice/processSlice';
import ProductCertificationReducer from 'slice/productCertificationSlice';
import productObjectReducer from 'slice/productObjectSlice';
import productOptionReducer from 'slice/productOptionSlice';
import productReducer from 'slice/productSlice';
import productUnitReducer from 'slice/productUnitSlice';
import proposalItemLogReducer from 'slice/proposalItemLogSlice';
import proposalItemsReducer from 'slice/proposalItemSlice';
import proposalPolicyReducer from 'slice/proposalPolicySlice';
import sectionReducer from 'slice/sectionSlice';
import stampReducer from 'slice/stampSlice';
import stepReducer from 'slice/stepSlice';
import subCategoryReducer from 'slice/subCategorySlice';
import supplierCouponReducer from 'slice/supplierCouponSlice';
import uploadReducer from 'slice/uploadSlice';
import userCustomDomainReducer from 'slice/userCustomDomainSlice';

import appDeviceReducer from '../slice/appDeviceSlice';
import appRouteSlice from '../slice/appRouteSlice';
import autoForecastLogReducer from '../slice/autoForecastLogSlice';
import autoForecastPolicySettingReducer from '../slice/autoForecastPolicySettingSlice';
import autoForecastSettingDetailItemReducer from '../slice/autoForecastSettingDetailItemSlice';
import autoForecastSettingDetailReducer from '../slice/autoForecastSettingDetailSlice';
import autoForecastSettingReducer from '../slice/autoForecastSettingSlice';
import autoOrderSettingReducer from '../slice/autoOrderSettingSlice';
import billItemReducer from '../slice/billItemSlice';
import billReducer from '../slice/billSlice';
import breadcrumbReducer from '../slice/breadcrumbSlice';
import createBillReducer from '../slice/createBillSlice';
import digitalMenuShareCustomerReducer from '../slice/digitalMenuShareCustomerSlice';
import digitalMenuShareReducer from '../slice/digitalMenuShareSlice';
import entityBlogCategoryReducer from '../slice/entityBlogCategorySlice';
import entityBlogReducer from '../slice/entityBlogSlice';
import entityBudgetSubItemReducer from '../slice/entityBudgetSubItemSlice';
import entityContactRequestReducer from '../slice/entityContactRequestSlice';
import entityCustomerGroupReducer from '../slice/entityCustomerGroupSlice';
import entityDocumentCategoryReducer from '../slice/entityDocumentCategorySlice';
import entityDocumentSubCategoryReducer from '../slice/entityDocumentSubCategorySlice';
import entityNotifyReducer from '../slice/entityNotifySlice';
import entityPricePolicyReducer from '../slice/entityPricePolicySlice';
import entityProductReducer from '../slice/entityProductSlice';
import entityProposalPolicyReducer from '../slice/entityProposalPolicySlice';
import entityReportReducer from '../slice/entityReportSlice';
import entityRoleReducer from '../slice/entityRoleSlice';
import entitySalePromotionReducer from '../slice/entitySalePromotionSlice';
import entityShippingListReducer from '../slice/entityShippingListSlice';
import entityTaskListReducer from '../slice/entityTaskListSlice';
import entityZaloOAReducer from '../slice/entityZaloOASlice';
import entityZNSTemplateReducer from '../slice/entityZNSTemplateSlice';
import errorReducer from '../slice/errorSlice';
import exportBillModalReducer from '../slice/exportBillModalSlice';
import inventoryAuditReducer from '../slice/inventoryAuditSlice';
import materialReducer from '../slice/materialSlice';
import modalReducer from '../slice/modalSlice';
import orderTaskModalReducer from '../slice/orderTaskModalSlice';
import partnerPathReducer from '../slice/partnerPathSlice';
import quickStartReducer from '../slice/quickStartSlice';
import receiptReducer from '../slice/receiptSlice';
import returnBillReducer from '../slice/returnBillSlice';
import revenueStatisticReducer from '../slice/revenueStatisticSlice';
import searchResultReducer from '../slice/searchResultSlice';
import standardObjectTypeReducer from '../slice/standardObjectTypeSlice';
import standardProcessReducer from '../slice/standardProcessSlice';
import standardProductReducer from '../slice/standardProductSlice';
import standardStepReducer from '../slice/standardStepSlice';
import stockReducer from '../slice/stockSlice';
import updateBillReducer from '../slice/updateBillSlice';
import UpdateOrderReducer from '../slice/updateOrderSlice';
import videoReducer from '../slice/videoSlice';

/**
 * Merges the main reducer with the router state and dynamically injected reducers
 */
const rootReducer = combineReducers({
  app: appReducer,
  address: addressReducer,
  area: areaReducer,
  branch: branchReducer,
  bank: bankReducer,
  bankAccount: bankAccountReducer,
  banner: bannerReducer,
  combo: comboReducer,
  entityCoupon: entityCouponReducer,
  category: categoryReducer,
  subCategory: subCategoryReducer,
  color: colorReducer,
  campaign: campaignReducer,
  coBuy: coBuyReducer,
  customer: customerReducer,
  coBuyProduct: coBuyProductReducer,
  gallery: galleryReducer,
  auth: authReducer,
  entityArea: entityAreaReducer,
  entityCertification: entityCertificationReducer,
  entityCategory: entityCategoryReducer,
  entitySubCategory: entitySubCategoryReducer,
  entityCartItem: entityCartItemReducer,
  entityDeliveryFee: entityDeliveryFeeReducer,
  entityDistanceShippingFee: entityDistanceShippingFeeReducer,
  entityCustomShippingFee: entityCustomShippingFeeReducer,
  entityLocationShippingFee: entityLocationShippingFeeReducer,
  entityPackingFee: entityPackingFeeReducer,
  entityLocationExist: entityLocationExistReducer,
  entityLocationFreeShip: entityEntityLocationFreeShipReducer,
  entityOption: entityOptionReducer,
  entityGroup: entityGroupReducer,
  entityCustomerGroup: entityCustomerGroupReducer,
  group: groupReducer,
  partner: partnerReducer,
  diary: diaryReducer,
  process: processReducer,
  product: productReducer,
  entityProduct: entityProductReducer,
  collaboratorProduct: collaboratorProductReducer,
  productObject: productObjectReducer,
  proposalItems: proposalItemsReducer,
  proposalItemLog: proposalItemLogReducer,
  proposalPolicy: proposalPolicyReducer,
  pricePolicy: pricePolicyReducer,
  stamp: stampReducer,
  orderItemLog: orderItemLogReducer,
  orderItems: orderItemsReducer,
  order: orderReducer,
  orderReducer: orderTaskReducer,
  orderTaskModal: orderTaskModalReducer,
  option: optionReducer,
  exportBillModal: exportBillModalReducer,
  createOrder: createOrderReducer,
  updateOrder: UpdateOrderReducer,
  productOption: productOptionReducer,
  entityShippingList: entityShippingListReducer,
  section: sectionReducer,
  step: stepReducer,
  certification: certificationReducer,
  ProductCertification: ProductCertificationReducer,
  organization: organizationReducer,
  employee: employeeReducer,
  modal: modalReducer,
  chat: chatReducer,
  notification: notificationReducer,
  account: accountReducer,
  invitation: invitationReducer,
  invitationProduct: invitationProductReducer,
  upload: uploadReducer,
  material: materialReducer,
  entityMaterialCategory: entityMaterialCategoryReducer,
  entityMaterialSubCategory: entityMaterialSubCategoryReducer,
  supplierCoupon: supplierCouponReducer,
  entityRelativeQuantity: entityRelativeQuantityReducer,
  location: locationReducer,
  productUnit: productUnitReducer,
  quickStart: quickStartReducer,
  digitalMenu: digitalMenuReducer,
  digitalMenuCategoryProduct: digitalMenuCategoryProductReducer,
  digitalMenuCategory: digitalMenuCategoryReducer,
  entityNotify: entityNotifyReducer,
  entityReport: entityReportReducer,
  digitalMenuCategoryProposalItem: digitalMenuCategoryProposalItemReducer,
  appDevice: appDeviceReducer,
  appRoute: appRouteSlice,
  partnerPath: partnerPathReducer,
  autoOrderSettingDetail: autoOrderSettingDetailReducer,
  autoOrderSetting: autoOrderSettingReducer,
  autoForecastSetting: autoForecastSettingReducer,
  autoForecastSettingDetail: autoForecastSettingDetailReducer,
  entityPricePolicy: entityPricePolicyReducer,
  entityProposalPolicy: entityProposalPolicyReducer,
  autoForecastSettingDetailItem: autoForecastSettingDetailItemReducer,
  autoForecastPolicySetting: autoForecastPolicySettingReducer,
  autoForecastLog: autoForecastLogReducer,
  video: videoReducer,
  breadcrumb: breadcrumbReducer,
  createBill: createBillReducer,
  bill: billReducer,
  revenueStatistic: revenueStatisticReducer,
  debtStatistic: debtStatisticReducer,
  entityDocumentSubCategory: entityDocumentSubCategoryReducer,
  entityDocumentCategory: entityDocumentCategoryReducer,
  documentCategory: documentCategoryReducer,
  receipt: receiptReducer,
  entityBudgetSubItem: entityBudgetSubItemReducer,
  entityBudgetItem: entityBudgetItemReducer,
  budgetItem: budgetItemReducer,
  updateBill: updateBillReducer,
  entityTaskList: entityTaskListReducer,
  returnBill: returnBillReducer,
  entityZaloOA: entityZaloOAReducer,
  entityZNSTemplate: entityZNSTemplateReducer,
  customerGroupOrder: customerGroupUserReducer,
  userCustomDomain: userCustomDomainReducer,
  standardObjectType: standardObjectTypeReducer,
  standardProcess: standardProcessReducer,
  standardProduct: standardProductReducer,
  standardStep: standardStepReducer,
  entityMaterial: entityMaterialReducer,
  materialCategory: materialCategoryReducer,
  searchResult: searchResultReducer,
  entityDiary: entityDiaryReducer,
  digitalMenuShare: digitalMenuShareReducer,
  digitalMenuShareCustomer: digitalMenuShareCustomerReducer,
  billItem: billItemReducer,
  entityRole: entityRoleReducer,
  error: errorReducer,
  entitySalePromotion: entitySalePromotionReducer,
  entityBlog: entityBlogReducer,
  entityBlogCategory: entityBlogCategoryReducer,
  entityLarkApp: entityLarkAppReducer,
  entityLarkBase: entityLarkBaseReducer,
  entitySetting: entitySettingReducer,
  entityContactRequest: entityContactRequestReducer,
  stock: stockReducer,
  inventoryAudit: inventoryAuditReducer,
});

export default rootReducer;
